<template>
  <SAIBtn
    :disable="disable"
    :href="href"
    :type="type"
    target="_blank"
    class="rounded-borders"
    outline
    :padding="padding"
    no-caps
    :rounded="false"
    border-width="1px"
    color="grey-4"
    @click="$emit('click')"
  >
    <div class="row items-center justify-start full-width">
      <QIcon
        v-if="icon"
        :name="icon"
        :color="iconColor"
        :size="iconSize"
        class="q-mr-sm"
      />
      <slot>
        <span class="text-grey-8 text-weight-medium">
          {{ label }}
        </span>
      </slot>
    </div>
  </SAIBtn>
</template>

<script>
import { SAIBtn } from 'ecx.saigon.ui.common';
import { QIcon } from 'quasar';

export default {
  name: 'DocumentBtn',
  props: {
    disable: Boolean,
    href: String,
    label: String,
    type: {
      type: String,
      default: 'a'
    },
    icon: {
      type: String,
      default: 'eva-file-text-outline'
    },
    padding: {
      type: String,
      default: '10px md'
    },
    iconColor: {
      type: String,
      default: 'primary'
    },
    iconSize: {
      type: String,
      default: 'xs'
    }
  },
  components: {
    SAIBtn,
    QIcon
  }
};
</script>
